import React, { useState } from "react"
import Text from "@/app/(site)/_components/Atoms/Text"

import { Spinner } from "../../../Molecules/Spinner"

export type TextFieldProps = {
    id: string
    label?: string
    size?: "small" | "medium" | "large"
    theme: "light" | "dark"
    single?: "true" | "false"
    status?: "success" | "error"
    type?: "email" | "search" | "text" | "password" | "submit-text" | "tel"
    placeholder: string
    success?: boolean | undefined
    loading?: boolean
} & React.InputHTMLAttributes<HTMLInputElement>

const KlaviyoInputField = React.forwardRef<HTMLInputElement, TextFieldProps>(
    (
        {
            id,
            label,
            theme,
            type,
            success,
            placeholder,
            size,
            className,
            loading,
            ...props
        },
        ref
    ) => {
        const [isFocused, setIsFocused] = useState(false)
        const baseClasses = "border py-16 px-24 rounded-full w-full placeholder-gray-500"
        const themeClasses =
            theme === "dark"
                ? "placeholder-white bg-transparent hover:bg-main-white focus:bg-main-white hover:text-main-black focus:text-main-black border-white"
                : "bg-main-white text-gray-700"
        const hoverFocusClasses =
            "hover:bg-gray-200 focus:bg-white focus:text-black hover:placeholder-main-black focus:placeholder-main-black"
        const focusClasses = "focus:ring-2 focus:ring-blue-500 focus:outline-none"
        const inputWrapperClasses = "relative"

        const combinedInputClasses = `${baseClasses} ${themeClasses} ${hoverFocusClasses} ${focusClasses} ${className}`

        return (
            <div
                className={`flex flex-col gap-1 ${theme === "dark" ? "text-main-white" : "text-main-dark-grey"}`}
            >
                {label && (
                    <label
                        htmlFor={id}
                        className={`mb-8 ${theme === "dark" ? "text-main-white" : "text-main-black"}`}
                    >
                        <Text size="small" weight="regular">
                            {label}
                        </Text>
                    </label>
                )}
                <div className={inputWrapperClasses}>
                    {loading === true && <Spinner classes="absolute mt-20 right-30" />}
                    <Text size="medium" weight="regular">
                        <input
                            ref={ref}
                            id={id}
                            type={type}
                            placeholder={placeholder}
                            className={combinedInputClasses}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            {...props}
                        />
                    </Text>
                </div>
            </div>
        )
    }
)

KlaviyoInputField.displayName = "TextField"

export default KlaviyoInputField
